module.exports = __webpack_public_path__ + "static/WEDDING E&M-187-09b27473253db64654d998d64d11c43d.jpg";